// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom';

import BaseCalendar from './base-calendar';
import CalendarWidget from './calendar-widget';
import { BaseCalendarSettings } from './models';


// Mount CalendarWidget block
const widgetMounts = Array.from(
  document.querySelectorAll<HTMLDivElement>('.calendar-widget-root')
);

const widgetSettingsList = (window as any).bootstrap?.widgetSettings ?? [];

widgetMounts.forEach((mount, idx) => {
  const settings = widgetSettingsList[idx] as BaseCalendarSettings | undefined;

  const target = (settings as any).widgetId
    ? document.getElementById((settings as any).widgetId) || mount
    : mount;

  ReactDOM.render(<CalendarWidget {...settings} />, target);
});

// Mount Calendar
const pageMount = document.getElementById('calendar-root');
const pageSettings = (window as any).bootstrap?.pageSettings as BaseCalendarSettings | undefined;

if (pageMount && pageSettings) {
  ReactDOM.render(<BaseCalendar {...pageSettings} />, pageMount);
}